import React, { useContext } from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";

import GlobalContext from "../../context/GlobalContext";

const HeroSection = styled.section`
  padding: 120px 0 96px;
  background: var(--nd-black);
`;

const Badge = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  display: inline-block;
  padding: 4px 14px;
  border-radius: 4px;
  background: rgba(74, 158, 92, 0.15);
  color: var(--nd-success);
  margin-bottom: 24px;
`;

const HeroTitle = styled.h1`
  font-family: 'Doto', 'Space Mono', monospace;
  font-size: 64px;
  font-weight: 700;
  color: var(--nd-text-display);
  letter-spacing: -0.03em;
  line-height: 1;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    font-size: 40px;
  }
`;

const HeroSubtitle = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 20px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  max-width: 600px;
  margin-bottom: 32px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const PrimaryButton = styled.button`
  font-family: 'Space Mono', monospace;
  font-size: 13px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 12px 24px;
  min-height: 44px;
  border-radius: 999px;
  border: none;
  background: var(--nd-text-display);
  color: var(--nd-black);
  cursor: pointer;
  transition: opacity 250ms cubic-bezier(0.25, 0.1, 0.25, 1);
  outline: none;
  &:hover { opacity: 0.85; }
`;

const SecondaryAnchor = styled.a`
  font-family: 'Space Mono', monospace;
  font-size: 13px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 12px 24px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  border: 1px solid var(--nd-border-visible);
  background: transparent;
  color: var(--nd-text-primary) !important;
  text-decoration: none !important;
  transition: border-color 250ms cubic-bezier(0.25, 0.1, 0.25, 1);
  outline: none;
  &:hover { border-color: var(--nd-text-primary); }
`;

const StaffingHero = () => {
  const gContext = useContext(GlobalContext);

  return (
    <HeroSection>
      <Container>
        <Badge>MENTORSHIP + STAFFING</Badge>
        <HeroTitle>
          Hire the junior.<br />
          Skip the recruiter.
        </HeroTitle>
        <HeroSubtitle>
          We place a Dioscuro-mentored junior into your team. If they're great,
          hire them at month six — no placement fee. That's the point.
        </HeroSubtitle>
        <ButtonRow>
          <PrimaryButton
            aria-label="Book a call"
            onClick={(e) => { e.preventDefault(); gContext.toggleContact(); }}
          >
            Book a call
          </PrimaryButton>
          <SecondaryAnchor
            href="/Dioscuro_Services_Brochure.pdf"
            download
            aria-label="Download brochure"
          >
            Download brochure
          </SecondaryAnchor>
        </ButtonRow>
      </Container>
    </HeroSection>
  );
};

export default StaffingHero;
